"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var GraphqlModule_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryCache = exports.GraphqlModule = void 0;
const core_1 = require("@rxdi/core");
const cache_1 = require("@apollo/client/cache");
const graphql_injection_1 = require("./graphql.injection");
const core_2 = require("@apollo/client/core");
const ws_1 = require("@apollo/client/link/ws");
const subscriptions_transport_ws_1 = require("subscriptions-transport-ws");
const utilities_1 = require("@apollo/client/utilities");
const context_1 = require("@apollo/client/link/context");
let GraphqlModule = GraphqlModule_1 = class GraphqlModule {
    static forRoot({ uri, pubsub, onRequest, cache, apolloRequestHandler, cancelPendingRequests, apolloClientOptions, } = {}, documents = {}) {
        const headers = {};
        const connections = {};
        return {
            module: GraphqlModule_1,
            providers: [
                {
                    provide: graphql_injection_1.GraphqlDocuments,
                    useValue: documents,
                },
                {
                    provide: graphql_injection_1.ApolloClient,
                    useFactory: () => new core_2.ApolloClient(Object.assign({ link: (0, core_2.concat)((0, core_2.from)([
                            (0, context_1.setContext)((operation) => __awaiter(this, void 0, void 0, function* () {
                                const method = onRequest || graphql_injection_1.noopHeaders;
                                let headersMap = (yield method.call(operation)) || {};
                                headersMap.forEach((v, k) => {
                                    headers[k] = v;
                                });
                                return {
                                    headers,
                                };
                            })),
                            new core_2.ApolloLink(typeof apolloRequestHandler === 'function'
                                ? apolloRequestHandler
                                : (operation, forward) => {
                                    /* Start cancel request */
                                    if (cancelPendingRequests) {
                                        return new core_2.Observable((observer) => {
                                            const context = operation.getContext();
                                            const connectionHandle = forward(operation).subscribe({
                                                next: (...arg) => observer.next(...arg),
                                                error: (...arg) => {
                                                    cleanUp();
                                                    observer.error(...arg);
                                                },
                                                complete: (...arg) => {
                                                    cleanUp();
                                                    observer.complete(...arg);
                                                },
                                            });
                                            const cleanUp = () => {
                                                connectionHandle === null || connectionHandle === void 0 ? void 0 : connectionHandle.unsubscribe();
                                                delete connections[context.requestTrackerId];
                                            };
                                            if (context.requestTrackerId) {
                                                const controller = new AbortController();
                                                controller.signal.onabort = cleanUp;
                                                operation.setContext(Object.assign(Object.assign({}, context), { fetchOptions: Object.assign({ signal: controller.signal }, context === null || context === void 0 ? void 0 : context.fetchOptions) }));
                                                if (connections[context.requestTrackerId]) {
                                                    // If a controller exists, that means this operation should be aborted.
                                                    connections[context.requestTrackerId].abort();
                                                }
                                                connections[context.requestTrackerId] = controller;
                                            }
                                            return connectionHandle;
                                        });
                                    }
                                    /* End cancel request */
                                    return forward(operation);
                                }),
                        ]), (0, core_2.split)(({ query }) => {
                            const { kind, operation } = (0, utilities_1.getMainDefinition)(query);
                            return kind === 'OperationDefinition' && operation === 'subscription';
                        }, (() => {
                            const wsLink = new ws_1.WebSocketLink(new subscriptions_transport_ws_1.SubscriptionClient(pubsub, {
                                lazy: true,
                                connectionParams: () => ({
                                    get authorization() {
                                        return headers['authorization'];
                                    },
                                }),
                                connectionCallback: (error) => {
                                    console.error('[Subscription]: ', error);
                                    if ((error === null || error === void 0 ? void 0 : error['message']) === 'Unauthorized') {
                                        wsLink['subscriptionClient'].close(false, false);
                                    }
                                },
                                reconnect: true,
                            }));
                            return wsLink;
                        })(), (0, core_2.createHttpLink)({ uri }))), cache: cache || new cache_1.InMemoryCache() }, apolloClientOptions)),
                },
            ],
        };
    }
};
GraphqlModule = GraphqlModule_1 = __decorate([
    (0, core_1.Module)({})
], GraphqlModule);
exports.GraphqlModule = GraphqlModule;
__exportStar(require("./graphql.injection"), exports);
__exportStar(require("./graphq.helpers"), exports);
var cache_2 = require("@apollo/client/cache");
Object.defineProperty(exports, "InMemoryCache", { enumerable: true, get: function () { return cache_2.InMemoryCache; } });
